import comp from './LoaderBar'
export default comp
